import { render, staticRenderFns } from "./InterventionRecordsForm.vue?vue&type=template&id=ff1bfb02&"
import script from "./InterventionRecordsForm.vue?vue&type=script&lang=js&"
export * from "./InterventionRecordsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VTextarea,
})
